export const endPoint="https://coding-challenge-api.aerolab.co"
const key="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MGY0ODg2OTY3Mjk2ZTAwMTk5NjQxM2UiLCJpYXQiOjE2MjY2Mzg0NDF9.54w7aOKqVOwHW_JfOtaZUDNW4qOML_E8siZ2HFf52fI"
export const headers={
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': `Bearer ${key}`
}
    
